import { useEffect, useRef } from 'react';
import posthog from 'posthog-js';
import { useLocation } from 'react-router-dom';

const POSTHOG_TOKEN = process.env.REACT_APP_PUBLIC_POSTHOG_TOKEN;
const POSTHOG_HOST = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;
const TARGET_ROUTE = '/questions/home';
const isPostHogReady =
  typeof window !== 'undefined' && Boolean(POSTHOG_TOKEN) && Boolean(POSTHOG_HOST);

function PostHogController() {
  const location = useLocation();
  const hasInitializedRef = useRef(false);
  const hasStartedCaptureRef = useRef(false);

  useEffect(() => {
    if (!isPostHogReady || hasInitializedRef?.current) {
      return;
    }

    posthog.init(POSTHOG_TOKEN, {
      api_host: POSTHOG_HOST,
      capture_pageview: false,
      capture_pageleave: false,
      autocapture: true,
    });

    // Keep tracking disabled by default and enable only on the target route.
    posthog.opt_out_capturing();
    hasInitializedRef.current = true;
  }, []);

  useEffect(() => {
    if (!isPostHogReady || !hasInitializedRef?.current) {
      return;
    }

    const isTargetRoute = location.pathname.includes(TARGET_ROUTE);

    if (isTargetRoute) {
      if (!hasStartedCaptureRef?.current) {
        posthog.opt_in_capturing();
        hasStartedCaptureRef.current = true;
      }
      posthog.capture('$pageview');
      return;
    }

    if (hasStartedCaptureRef?.current) {
      posthog.opt_out_capturing();
      hasStartedCaptureRef.current = false;
    }
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      if (isPostHogReady && hasInitializedRef?.current) {
        posthog.opt_out_capturing();
        hasStartedCaptureRef.current = false;
      }
    };
  }, []);

  return null;
}

export default PostHogController;
